import "../../../../assets/presentation/components/controls/text-input/text-input-prefix-BF43LRLE.css";
/* empty css                  */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-prefix.tsx
var TextInputPrefix = ({ className, children, testId, highlight }) => /* @__PURE__ */ jsx("span", {
	className: classNames(className, "text-input-prefix", { highlight }),
	"data-testid": testId,
	children
});
//#endregion
export { TextInputPrefix };

//# sourceMappingURL=text-input-prefix2.js.map